'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Pane = require('./Pane');

var _Pane2 = _interopRequireDefault(_Pane);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _SuccessAlertIcon = require('./SuccessAlertIcon');

var _SuccessAlertIcon2 = _interopRequireDefault(_SuccessAlertIcon);

var _QuestionAlertIcon = require('./QuestionAlertIcon');

var _QuestionAlertIcon2 = _interopRequireDefault(_QuestionAlertIcon);

var _DangerAlertIcon = require('./DangerAlertIcon');

var _DangerAlertIcon2 = _interopRequireDefault(_DangerAlertIcon);

var _WarningAlertIcon = require('./WarningAlertIcon');

var _WarningAlertIcon2 = _interopRequireDefault(_WarningAlertIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var minorScale = _theme2.default.minorScale,
    majorScale = _theme2.default.majorScale;


var getStyle = function getStyle(_ref) {
  var type = _ref.type,
      showTrim = _ref.showTrim;

  var trim = showTrim ? {
    '&:before': {
      content: '""',
      width: minorScale(1),
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      backgroundColor: _theme2.default.colors[type]
    }
  } : {};

  return (0, _glamor.css)(_extends({
    'boxShadow': _theme2.default.shadows[0] + ', inset 0 0 0 1px ' + _theme2.default.colors.borderColor
  }, trim));
};

var parseProps = function parseProps(_ref2) {
  var className = _ref2.className,
      type = _ref2.type,
      showTrim = _ref2.showTrim,
      props = _objectWithoutProperties(_ref2, ['className', 'type', 'showTrim']);

  return _extends({
    className: (0, _classnames2.default)('' + getStyle({ type: type, showTrim: showTrim }), className)
  }, props);
};

var AlertIcon = function AlertIcon(_ref3) {
  var type = _ref3.type,
      props = _objectWithoutProperties(_ref3, ['type']);

  switch (type) {
    case 'success':
      return _react2.default.createElement(_SuccessAlertIcon2.default, props);
    case 'question':
      return _react2.default.createElement(_QuestionAlertIcon2.default, props);
    case 'warning':
      return _react2.default.createElement(_WarningAlertIcon2.default, props);
    case 'danger':
      return _react2.default.createElement(_DangerAlertIcon2.default, props);
    default:
      return null;
  }
};

AlertIcon.propTypes = _extends({}, _SuccessAlertIcon2.default.propTypes);

AlertIcon.defaultProps = {
  marginTop: minorScale(1),
  marginRight: majorScale(2)
};

var Alert = function Alert(_ref4) {
  var children = _ref4.children,
      showIcon = _ref4.showIcon,
      props = _objectWithoutProperties(_ref4, ['children', 'showIcon']);

  return _react2.default.createElement(
    _Pane2.default,
    parseProps(props),
    showIcon && _react2.default.createElement(AlertIcon, { flexShrink: '0', type: props.type }),
    _react2.default.createElement(
      _Pane2.default,
      null,
      children
    )
  );
};

Alert.propTypes = _extends({}, _Pane2.default.propTypes, {
  type: _propTypes2.default.oneOf(['naked', 'success', 'warning', 'danger', 'question']),
  showIcon: _propTypes2.default.bool,
  showTrim: _propTypes2.default.bool
});

Alert.defaultProps = {
  showIcon: true,
  showTrim: true,
  type: 'naked',
  white: true,
  rounded: true,
  paddingX: majorScale(3),
  paddingY: majorScale(2),
  textStyle: 'body1',
  display: 'flex',
  width: '440px',
  position: 'relative',
  overflow: 'hidden'
};

Alert.displayName = 'Alert';

exports.default = Alert;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Alert.js
// module id = 1112
// module chunks = 0